/// <reference path="../../components/modal/modal.module.ts" />

module Meevo.Plugins.ControlGallery {
  'use strict';

  angular
    .module('meevo.plugins.controlgallery', []);

}   